import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_BALANCE } from "../../redux/Getbalance/types";

const Getbalanceload = ({id}) => {
  const dispatch = useDispatch();
  const viewClient = useSelector(
    (state) => state.getbalanceresucer.getbalancelist
  );
const getAllBalence = () =>{
  if(id !== undefined){
      dispatch({ type: GET_BALANCE , id:id});
  }
  const balance = viewClient.balance;
    const credit = viewClient.creditLimit;
    const lien = viewClient.lien;
    const getbalance = balance + credit - lien;
    const storecurrency = parseInt(getbalance);
    var currency = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      currencyDisplay: "name",
    }).format(storecurrency);
    const formattedcurrency = currency.replace(/[A-Za-z]/g, "");
    return formattedcurrency
}

  const totalBalances = React.useMemo(() => getAllBalence(), [viewClient.balance,id])
  return (
    <div className="header_right">
      <i class="ta"></i>
      {`₹${totalBalances}`}
    </div>
  );
};

export default Getbalanceload;
